module.exports = __webpack_public_path__ + "static/media/img_banner.3da59cd8.png";